export const tencentADASteps = [
  {
    id: 1,
    name: '项目',
    children: [
      {
        id: 1,
        name: '创建类型及账号'
      },
      {
        id: 2,
        name: '基础信息'
      },
      {
        id: 3,
        name: '计划应用与营销目标'
      },
      {
        id: 4,
        name: '投放版位'
      },
      {
        id: 5,
        name: '用户定向'
      },
      {
        id: 6,
        name: '排期及预算'
      }
    ]
  },
  {
    id: 2,
    name: '创意',
    children: [
      {
        id: 1,
        name: '创意形式'
      },
      {
        id: 2,
        name: '创意内容'
      }
    ]
  },
  {
    id: 3,
    name: '项目确认',
    children: [
      {
        id: 1,
        name: '批量项目确认'
      }
    ]
  }
]

export const tencentV3Steps = [
  {
    id: 1,
    name: '计划',
    children: [
      {
        id: 1,
        name: '创建类型及账号'
      },
      {
        id: 2,
        name: '基础信息'
      },
      {
        id: 3,
        name: '营销目标及场景'
      },
      {
        id: 4,
        name: '版位及定向'
      },
      {
        id: 5,
        name: '排期及预算'
      }
    ]
  },
  {
    id: 2,
    name: '创意',
    children: [
      {
        id: 1,
        name: '创意形式'
      },
      {
        id: 2,
        name: '创意内容'
      }
    ]
  },
  {
    id: 3,
    name: '计划确认',
    children: [
      {
        id: 1,
        name: '批量计划确认'
      }
    ]
  }
]
